export const stripSpaces = (s='') => s.replace(/\s+/g, '');
export const digitsOnly = (s='') => s.replace(/\D/g, '');
export const groupThousandsTR = (s='') => s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const formatCardNumber = (value='') => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/g, '');
    const parts = [];
    for (let i=0;i<v.length;i+=4) parts.push(v.substring(i, i+4));
    return parts.join(' ');
};